// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"_0hqNY","select-container":"y9Wcz","select":"suctj"};